// import React, { useState } from 'react';
// import profile from '../../assets/images/Student-avatar.jpg';

// const AttendanceRow = ({
//   student,
//   attendanceData,
//   index,
//   newArr,
//   onStatusChange,
// }) => {
//   // Find the initial status from `newArr`
//   const item = newArr?.find((i) =>
//     i?.phoneNumber?.includes(student?.phoneNumber)
//   );
//   const [p, setP] = useState(item?.status || 'A'); // Default to 'A' if no status is found

//   // Toggle attendance status
//   const handleClick = () => {
//     // Toggle logic
//     const updatedStatus = p === 'A' ? 'P' : 'A';

//     // Update local state
//     setP(updatedStatus);

//     // Propagate the change to the parent component via callback
//     onStatusChange(index, updatedStatus);
//   };

//   return (
//     <div className="">
//       <div
//         onClick={handleClick}
//         className={`rounded-xl cursor-pointer bg-white p-1 sm:p-2 ${
//           p === 'P' ? 'bg-green-200 text-green-700' : 'bg-red-200 text-red-800'
//         }`}
//       >
//         <div className="flex justify-between items-center">
//           <div className="element-font-5">
//             <h1 className="text-xl font-bold">{student.roleNo}</h1>
//           </div>
//           <div className="element-font-4">
//             {p === 'P' && (
//               <h1 className="text-xl font-bold text-green-700">{p}</h1>
//             )}
//             {p === 'A' && (
//               <h1 className="text-xl font-bold text-red-800">{p}</h1>
//             )}
//           </div>
//         </div>
//         <div className="flex items-center">
//           <div className="avatar">
//             <div className="w-4 sm:w-5 bg-secondary rounded-full">
//               {student?.imageURL ? (
//                 <img src={student?.imageURL} alt="profile" />
//               ) : (
//                 <img src={profile} alt="profile" />
//               )}
//             </div>
//           </div>
//           <div className="text-center font-Oswald ml-[2px]">
//             <p className="text-xs capitalize">
//               {student?.firstName.slice(0, 8)}
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttendanceRow;

import React from 'react';
import { useState } from 'react';
import profile from '../../assets/images/Student-avatar.jpg';

const AttendanceRow = ({ student, attendanceData, index, newArr }) => {
  const item = newArr?.find((i) =>
    i?.phoneNumber?.includes(student?.phoneNumber)
  );

  const [p, setP] = useState(item?.status);

  const handleClick = () => {
    if (item.status === 'A') {
      newArr[index].status = 'P';
      setP('P');
    } else {
      newArr[index].status = 'A';
      setP('A');
    }
  };

  return (
    <div className="">
      <div
        onClick={() => handleClick()}
        className={`rounded-xl cursor-pointer bg-white p-1 sm:p-2 ${
          p === 'P' ? 'bg-green-200 text-green-700' : 'bg-red-200 text-red-800'
        }`}
      >
        <div className="flex justify-between items-center">
          <div className="element-font-5">
            <h1 className="text-xl font-bold ">{student.roleNo}</h1>
          </div>
          <div className="element-font-4">
            {p === 'P' && (
              <h1 className="text-xl font-bold text-green-700">{p}</h1>
            )}
            {p === 'A' && (
              <h1 className="text-xl font-bold text-red-800">{p}</h1>
            )}
          </div>
        </div>
        <div className="flex items-center">
          <div className="avatar">
            <div className="w-4 sm:w-5 bg-secondary rounded-full">
              {student?.imageURL ? (
                <img src={student?.imageURL} alt="profile" />
              ) : (
                <img src={profile} alt="profile" />
              )}
            </div>
          </div>
          <div className="text-center font-Oswald ml-[2px]">
            <p className="text-xs capitalize">
              {student?.firstName.slice(0, 8)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttendanceRow;
